module.exports = __webpack_public_path__ + "static/media/open.63387a8d.png";